import React from "react";
import { Container } from "./Styled";

type HeaderProps = {
  children: React.ReactNode;
};

const Header: React.FunctionComponent<HeaderProps> = ({ children })  => {
  return (
    <Container>
        {children}
    </Container>
  );
};

export default Header; 